import axios from "../axiosConfig"; // Adjust the import path accordingly

const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const LensItemCreation = {
  insertLensItemCreation: async (PowerRangedata, isChanged = false) => {
    ;
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/LensItemCreation?IsUpdate=${isChanged}`;
      console.log(apiUrl);
      const response = await axios.post(
        apiUrl,
        {
          //lensPowerArray:processedData,
          lensPowerRang: {
            itemName: PowerRangedata.ItemName,
            itemId: parseFloat(PowerRangedata.ItemId),
            spH_Min: parseFloat(PowerRangedata.SPH_Min),
            spH_Max: parseFloat(PowerRangedata.SPH_Max),
            spH_Step: parseFloat(PowerRangedata.SPH_Step),
            cyL_Min: parseFloat(PowerRangedata.CYL_Min) || 0,
            cyL_Max: parseFloat(PowerRangedata.CYL_Max) || 0,
            cyL_Step: parseFloat(PowerRangedata.CYL_Step) || 0,
            axis: PowerRangedata.Axis.toString() || "",
            add_Min: parseFloat(PowerRangedata.Add_Min),
            add_Max: parseFloat(PowerRangedata.Add_Max),
            add_Step: parseFloat(PowerRangedata.Add_Step),
            eye: PowerRangedata.Eye,
            isCrossCompound: PowerRangedata.isCrossCompound,
          },
          itemIds: PowerRangedata.itemIds,
          isCrossCompound: PowerRangedata.isCrossCompound,
        },
        {
          withCredentials: true,
          credentials: "include",
        }
      );

      console.log("Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },

  // ************************* Get By Id ****************************
  getLensItemCreationById: async (data) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/GetLensPowers`;
      const response = await axios.post(
        apiUrl,
        {
          itemId: data.ItemId || data.itemId,
          spH_Min: data.SPH_Min || data.spH_Min,
          spH_Max: data.SPH_Max || data.spH_Max,
          cyL_Min: data.CYL_Min || data.cyL_Min,
          cyL_Max: data.CYL_Max || data.cyL_Max,
          axis: data.Axis || data.axis,
          add_Min: data.Add_Min || data.add_Min,
          add_Max: data.Add_Max || data.add_Max,
          eye: data.Eye || data.eye || "RL",
          // pageNumber: data.pageNumber || 1,
          // pageSize: data.pageSize || 50,
        },
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  getLensItemCreationById1: async (data) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/GetLensPowers`;

      const response = await axios.post(
        apiUrl,
        {
          itemId: data.ItemId || data.itemId,
          spH_Min: data.SPH_Min || data.spH_Min,
          spH_Max: data.SPH_Max || data.spH_Max,
          spH_Step: data.SPH_Step || 0.25,
          cyL_Min: data.CYL_Min || data.cyL_Min,
          cyL_Max: data.CYL_Max || data.cyL_Max,
          cyL_Step: data.CYL_Step || 0.25,
          axis: data.Axis || data.axis,
          add_Min: data.Add_Min || data.add_Min,
          add_Max: data.Add_Max || data.add_Max,
          eye: data.Eye || data.eye || "RL",
          pageNumber: data.pageNumber || 1,
          pageSize: data.pageSize || 10000,
        },
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  GetLensItemMaster: async () => {
    try {
      const apiUrl = `${WebApiUrl}/api/ItemMaster/GetItemMasters`;
      const response = await axios.post(
        apiUrl,
        {
          filter: [
            {
              fieldName: "iAttributeParent",
              operatorName: "equal",
              compareValue: "0",
            },
          ],
          order: [],
          pageNumber: 1,
          pageSize: 50000,
        },
        {
          withCredentials: true,
          credentials: "include",
        }
      );
      console.log("Response:", response);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // ************************* Delete ****************************
  deleteLensItemCreation: async (LensItemId) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation?LensItemId=${LensItemId}`;
      const response = await axios.delete(apiUrl, {
        withCredentials: true,
      });
      console.log("Delete Response:", response.data.result);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // *************************** Update ***************************

  updateLensItemCreation: async (data) => {
    ;
    const processedData = data.map((loop) => ({
      billSeries: loop.billSeries,
      assignToShow: loop.assignToShow,
      accountId: loop.accountId,
      accountTitle: loop.accountTitle,
    }));

    var LensItemId = processedData[0].billSeries;
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation?LensItemId=${LensItemId}`;
      console.log(apiUrl);
      const response = await axios.put(
        apiUrl,
        {
          processedData,
        },
        {
          withCredentials: true,
          credentials: "include",
        }
      );

      console.log("Response:", response.data);
      return response.data.isSuccess;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },

  // ************************* Get By Id ****************************
  getLensItemCreationByItemId: async (itemId) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/GetItemPowerByItemId?ItemMasterId=${itemId}`;
      const response = await axios.get(
        apiUrl,
        {},
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  UpdateLensItemPower: async (data) => {
    ;
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/UpdateLensItemPower`;
      console.log(apiUrl);
      const response = await axios.put(
        apiUrl,
        {
          data,
        },
        {
          withCredentials: true,
          credentials: "include",
        }
      );

      console.log("Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },

  GetLensStockReport1: async (filter) => {
    const apiUrl = `${WebApiUrl}/api/LensItemCreation/GetLensStockReport1`;

    return await axios.post(apiUrl, filter, {
      withCredentials: true,
      credentials: "include",
    });
  },

  CreateNewBarcode: async (ItemId, IsBarcodeSetDefault) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/CreateNewBarcode?ItemId=${ItemId}&IsBarcodeSetDefault=${IsBarcodeSetDefault}`;
      const response = await axios.get(
        apiUrl,
        {},
        {
          withCredentials: true,
          credentials: "include",
        }
      );
      console.log("Response:", response.data.result);
      //setEditCallBack(response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  insertLensItemCreation: async (PowerRangedata, isChanged = false) => {
    ;
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/LensItemCreation?IsUpdate=${isChanged}`;
      console.log(apiUrl);
      const response = await axios.post(
        apiUrl,
        {
          //lensPowerArray:processedData,
          lensPowerRang: {
            itemName: PowerRangedata.ItemName,
            itemId: parseFloat(PowerRangedata.ItemId),
            spH_Min: parseFloat(PowerRangedata.SPH_Min),
            spH_Max: parseFloat(PowerRangedata.SPH_Max),
            spH_Step: parseFloat(PowerRangedata.SPH_Step),
            cyL_Min: parseFloat(PowerRangedata.CYL_Min) || 0,
            cyL_Max: parseFloat(PowerRangedata.CYL_Max) || 0,
            cyL_Step: parseFloat(PowerRangedata.CYL_Step) || 0,
            axis: PowerRangedata.Axis.toString() || "",
            add_Min: parseFloat(PowerRangedata.Add_Min),
            add_Max: parseFloat(PowerRangedata.Add_Max),
            add_Step: parseFloat(PowerRangedata.Add_Step),
            eye: PowerRangedata.Eye,
            // isCrossCompound: PowerRangedata.isCrossCompound,
            barcodeWithlensPower : false
          },
          itemIds: PowerRangedata.itemIds,
          isCrossCompound: PowerRangedata.isCrossCompound,
        },
        {
          withCredentials: true,
          credentials: "include",
        }
      );

      console.log("Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },

  CreateLensPowerOptionalField: async (data, MasterType) => {
    ;
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/CreateLensPowerOptionalField?MasterType=${MasterType}`;
      console.log(apiUrl);
      const response = await axios.post(apiUrl, data, {
        withCredentials: true,
        credentials: "include",
      });

      console.log("Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);

      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },

  // ************************* Get By Id ****************************
  GetLensPowerOptionalField: async (masterType) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/GetLensPowerOptionalField?masterType=${masterType}`;
      const response = await axios.get(
        apiUrl,
        {},
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // ************************* Delete optional field ****************************
  DeleteLensPowerOptionalFieldsByIds: async (data) => {
    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/DeleteLensPowerOptionalFieldsByIds`;
      const response = await axios.post(apiUrl, data, {
        withCredentials: true,
      });
      console.log("Delete Response:", response.data.result);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // ************************* Delete optional field ****************************
  DeleteRangeWiseLensPowerAsync: async (data , SelectedAxis) => {
    ;
    var data1 = {
      itemId: data.ItemId || "",
      spH_Min: data.SPH_Min || 0,
      spH_Max: data.SPH_Max || 0,
      spH_Step: data.SPH_Step || 0.25,
      cyL_Min: data.CYL_Min || 0,
      cyL_Max: data.CYL_Max || 0,
      cyL_Step: data.CYL_Step || 0.25,
      axis: String(SelectedAxis) || 0,
      add_Min: data.Add_Min || 0,
      add_Max: data.Add_Max || 0,
      add_Step: data.Add_Step || 0.25,
      eye: data.Eye || "RL",
      pageNumber: 1,
      pageSize: 10000,
    };

    try {
      const apiUrl = `${WebApiUrl}/api/LensItemCreation/DeleteRangeWiseLensPowerAsync`;
      const response = await axios.post(apiUrl, data1, {
        withCredentials: true,
        credentials: "include",
      });
      console.log("Delete Response:", response.data.result);
      return response.data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },
};

export default LensItemCreation;
